// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ipDy","inner":"Footer_inner__1zQbx"};